import { useOrchestrator } from '../core/context';
export function useOrchestratorState() {
  const {
    isLoading,
    currentStep,
    currentParams,
    currentFlowIndex,
    currentStepIndex,
    totalSteps,
    isComplete,
    isFirstStep,
    isLastStep,
    progress
  } = useOrchestrator();
  return {
    isLoading,
    currentStep,
    currentParams,
    currentFlowIndex,
    currentStepIndex,
    totalSteps,
    isComplete,
    isFirstStep,
    isLastStep,
    progress
  };
}
//# sourceMappingURL=useOrchestratorState.js.map